import ms from 'ms';
const isDateWithinInterval = ({ date, interval }) => Math.abs(date.getTime() - Date.now()) < interval;
const ordersAnalyticsPlugin = ({ analytics, ordersAtom, }) => {
    let unsubscribe;
    const onStart = () => {
        analytics.requireDefaultEventProperties(['assetExchangedLast90']);
        unsubscribe = ordersAtom.observe((orders) => {
            const assetExchangedLast90 = [...orders].some((order) => isDateWithinInterval({ date: order.date, interval: ms('90d') }));
            analytics.setDefaultEventProperties({ assetExchangedLast90 });
        });
    };
    const onStop = () => unsubscribe?.();
    return { onStart, onStop };
};
const ordersAnalyticsPluginDefinition = {
    id: 'ordersAnalyticsPlugin',
    type: 'plugin',
    factory: ordersAnalyticsPlugin,
    dependencies: ['analytics', 'ordersAtom'],
    public: true,
};
export default ordersAnalyticsPluginDefinition;
